export type ApiSource = 'MSW' | 'REGISTRY' | 'SERVER';

interface RuntimeConfig {
  VITE_API_BASE_URL: string;
  VITE_API_SOURCE: string;
  VITE_API_MOCK_LATENCY_MS: string;
  VITE_TILE_URL: string;
  VITE_MAP_MIN_ZOOM: string;
  VITE_MAP_MAX_ZOOM: string;
  VITE_CORRIDOR_NM: string;
  VITE_OIDC_AUTHORITY: string;
  VITE_OIDC_CLIENT_ID: string;
  VITE_OIDC_REDIRECT_URI: string;
  VITE_OIDC_POST_LOGOUT_REDIRECT_URI: string;
  VITE_OIDC_PROJECT_ID: string;
}

const runtimeConfig: Partial<RuntimeConfig> =
  (window as unknown as { __CONFIG__?: Partial<RuntimeConfig> }).__CONFIG__ ?? {};

function env(key: keyof RuntimeConfig): string {
  return runtimeConfig[key] ?? import.meta.env[key] ?? '';
}

function resolveApiSource(): ApiSource {
  const raw = env('VITE_API_SOURCE').toUpperCase();
  if (raw === 'SERVER' || raw === 'REGISTRY') return raw;
  return 'MSW';
}

export const config = {
  apiBaseUrl: env('VITE_API_BASE_URL') || '/api',
  apiSource: resolveApiSource(),
  mockLatencyMs: Number(env('VITE_API_MOCK_LATENCY_MS')) || 0,
  tileUrl: env('VITE_TILE_URL'),
  mapMinZoom: Number(env('VITE_MAP_MIN_ZOOM')) || 3,
  mapMaxZoom: Number(env('VITE_MAP_MAX_ZOOM')) || 14,
  corridorNm: Number(env('VITE_CORRIDOR_NM')) || 300,
  oidcAuthority: env('VITE_OIDC_AUTHORITY'),
  oidcClientId: env('VITE_OIDC_CLIENT_ID'),
  oidcRedirectUri: env('VITE_OIDC_REDIRECT_URI') || `${window.location.origin}/auth/callback`,
  oidcPostLogoutRedirectUri: env('VITE_OIDC_POST_LOGOUT_REDIRECT_URI') || window.location.origin,
  oidcProjectId: env('VITE_OIDC_PROJECT_ID'),
} as const;
